import React, { useEffect, useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import MarkEmailUnreadIcon from "@mui/icons-material/MarkEmailUnread";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Colors } from "../../Theme/Theme";
import { Forms, WEBSITE_INQUIRY_TYPE } from "../../api/requests/Forms";

// Admin dashboard card showing how many website enquiries are still un-actioned.
const NewInquiriesBanner = () => {
  const navigate = useNavigate();
  const [count, setCount] = useState(null);

  useEffect(() => {
    Forms.getForms({ page: 1, limit: 1, type: WEBSITE_INQUIRY_TYPE, status: "new" })
      .then((res) => setCount(Number(res?.pagination?.total) || 0))
      .catch(() => setCount(null));
  }, []);

  if (count === null) return null;

  return (
    <Box sx={{
      mb: 3, p: 2, borderRadius: "12px", backgroundColor: Colors.white,
      border: `1px solid ${count > 0 ? Colors.blueBorder : Colors.dividerColor}`,
      display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2, flexWrap: "wrap",
    }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
        <Box sx={{
          width: 40, height: 40, borderRadius: "10px", backgroundColor: Colors.blueSoft,
          display: "flex", alignItems: "center", justifyContent: "center", color: Colors.primary,
        }}>
          <MarkEmailUnreadIcon sx={{ fontSize: 20 }} />
        </Box>
        <Box>
          <Typography sx={{ fontWeight: 700, fontSize: "15px", color: Colors.primaryTextColor }}>
            {count > 0 ? `${count} new website ${count === 1 ? "enquiry" : "enquiries"}` : "No new website enquiries"}
          </Typography>
          <Typography sx={{ fontSize: "12px", color: Colors.secondaryColor }}>
            {count > 0 ? "Submitted from the home page and waiting for a callback." : "You're all caught up."}
          </Typography>
        </Box>
      </Box>
      <Button
        variant={count > 0 ? "contained" : "outlined"}
        endIcon={<ArrowForwardIcon />}
        onClick={() => navigate("/form-responses")}
        sx={{ textTransform: "none", borderRadius: "8px", fontWeight: 600, boxShadow: "none" }}
      >
        View enquiries
      </Button>
    </Box>
  );
};

export default NewInquiriesBanner;
